export const TEST_STRIPE_PUBLIC_KEY = 'pk_test_51MworqI9U8J9s9SHdayRvmL9HlldgcSxbCjX0AJ92raFYrFg2Gg9T3b67ViSwXsC6pdr0w7jkuljwuxLIA2kpoHR00FwlcJxlZ';
export const STRIPE_PUBLIC_KEY = 'pk_live_51MworqI9U8J9s9SH475fJTLtgRiIo7ARBJWNNiW90sTH0qZVOfVfplIbycgZJKi3Zy4m6TEyeyugezMmsCBwyiF9006BYgyjwt';
